import { ActionIcon, ScrollArea, Stack, Table, Text } from '@mantine/core';
import { IconEdit, IconTrash } from '@tabler/icons-react';

import { IProdoqRoleResponse } from '../../../../../../shared/types/prodoq';

interface RoleRegListPanelProps {
  roleData: IProdoqRoleResponse[];
  onClickEdit: (item: IProdoqRoleResponse) => void;
  onConfirmDelete: (id: number) => void;
}

export default function RoleRegListPanel(props: RoleRegListPanelProps) {
  const { roleData, onClickEdit, onConfirmDelete } = props;

  return (
    <Stack flex={1}>
      <Text fw={500} size="sm">
        등록된 역할 목록
      </Text>
      <ScrollArea mah={360} type="auto" offsetScrollbars>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>순서</Table.Th>
              <Table.Th>역할명</Table.Th>
              <Table.Th>관리</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {roleData.map((role) => (
              <Table.Tr key={role.id}>
                <Table.Td>{role.order}</Table.Td>
                <Table.Td>
                  {role.roleName} ({role.roleNameEn})
                </Table.Td>
                <Table.Td>
                  <ActionIcon variant="outline" size="md" onClick={() => onClickEdit(role)}>
                    <IconEdit size={16} />
                  </ActionIcon>
                  <ActionIcon
                    variant="outline"
                    color="red"
                    size="md"
                    ml={8}
                    disabled={role.order === 1}
                    onClick={() => onConfirmDelete(role.id)}
                  >
                    <IconTrash size={16} />
                  </ActionIcon>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </ScrollArea>
    </Stack>
  );
}
